import {
  MonitorIcon,
  PaletteIcon,
  ServerIcon,
  MailIcon,
  SearchIcon,
  DatabaseIcon,
} from 'lucide-react'
import type { ServiceItem } from '../types/content'

export const services: ServiceItem[] = [
  {
    title: 'Websites',
    description:
      'Een website die gevonden wordt en vertrouwen wekt. Gebouwd op de vragen die jouw klanten stellen.',
    icon: MonitorIcon,
    link: '/websites',
  },
  {
    title: 'Digitale vormgeving',
    description:
      'Logo, huisstijl, drukwerk en digitale sjablonen. Opgeleverd in Figma, zodat je zelf kunt aanpassen.',
    icon: PaletteIcon,
    link: '/vormgeving',
  },
  {
    title: 'Hosting',
    description:
      'Beheerde hosting met dagelijkse back-ups, updates en monitoring. Wij houden de techniek bij.',
    icon: ServerIcon,
    link: '/hosting',
  },
  {
    title: 'E-mail',
    description:
      'Zakelijke e-mail op je eigen domein, netjes ingericht en beveiligd tegen spam en phishing.',
    icon: MailIcon,
    link: '/email',
  },
  {
    title: 'SEO',
    description:
      'Beter vindbaar op wat ondernemers en particulieren in Noord-Holland Noord echt zoeken.',
    icon: SearchIcon,
    link: '/seo',
  },
  {
    title: 'CorePrint',
    description:
      'Onze methodiek voor wie verder wil groeien. Eerst meten welke vraag er is, daarna bouwen.',
    icon: DatabaseIcon,
    link: 'https://coreprint.nl/',
    external: true,
  },
]
